import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import * as fromStore from '../../../../store/ui';
import { UiState } from '../../../../store/ui';

@Component({
    selector: 'app-locations-module',
    templateUrl: './locations-module.component.html',
    styleUrls: ['./locations-module.component.scss'],
    standalone: false
})
export class LocationsModuleComponent implements OnInit {
  isSidebarOpen$ = combineLatest([
    this.store.select(fromStore.selectIsSidebarOpened),
    this.breakpointObserver.observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge,
    ]),
  ]).pipe(
    map(([isSidebarOpen, breakpointState]) =>
      isSidebarOpen || breakpointState.matches
    ),
    distinctUntilChanged()
  );

  sidebarMode$ = this.breakpointObserver.observe([Breakpoints.Large, Breakpoints.XLarge, Breakpoints.Medium])
    .pipe(map(result => result.matches ? 'side' : 'over'));

  constructor(private store: Store<{ ui: UiState }>, private breakpointObserver: BreakpointObserver) {}

  ngOnInit() {}

  onActivate() {
    window.scroll(0, 0);
    document.body.scrollTop = 0;
  }

  onClose() {
    this.store.dispatch(fromStore.closeSidebar());
  }
}
